import { ChangeDetectionStrategy, Component, effect, inject } from '@angular/core';

import { AppError, DIALOG_DATA, DialogRef } from '@hglobal/common';
import { TranslateModule } from '@ngx-translate/core';

import { ConfirmDialogContentComponent } from '@pp/common';
import { DialogData } from '@pp/core/entities';
import { GlobalToastService } from '@pp/core/services';
import { ShellStore } from '@pp/shell';

@Component({
  selector: 'pp-confirm-toggle-agent-account-sales',
  imports: [ConfirmDialogContentComponent, TranslateModule],
  templateUrl: './confirm-toggle-agent-account-sales.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmToggleAgentAccountSalesComponent {
  readonly #shellStore = inject(ShellStore);
  readonly #globalToastService = inject(GlobalToastService);
  readonly #dialogRef = inject(DialogRef);
  readonly #dialog = inject<DialogData<ConfirmToggleAgentAccountSalesComponent, { enableMode: boolean }>>(DIALOG_DATA);

  enableMode = this.#dialog.data.enableMode;
  description = this.enableMode ? 'shell.header.salesToggle.enable.description' : 'shell.header.salesToggle.disable.description';
  confirmation = this.enableMode ? 'shell.header.salesToggle.enable.actions.confirm' : 'shell.header.salesToggle.disable.actions.confirm';
  status: 'danger' | 'success' | 'default' | 'warn' = this.enableMode ? 'danger' : 'warn';

  changeAgentFeatureAvailabilitySuccessEffect = effect(() => {
    const success = this.#shellStore.isChangeAgentFeatureAvailabilitySuccess();
    if (success) {
      this.#shellStore.resetChangeAgentFeatureAvailability();
      queueMicrotask(() => this.closeDialog(success));
    }
  });

  changeAgentFeatureAvailabilityFailureEffect = effect(() => {
    const error = this.#shellStore.changeAgentFeatureAvailabilityError();
    if (error) {
      this.#shellStore.resetChangeAgentFeatureAvailability();
      this.#onChangeError(error);
    }
  });

  confirm(): void {
    this.#shellStore.changeAgentFeatureAvailability(this.enableMode);
  }

  closeDialog(success?: boolean): void {
    this.#dialogRef.close(success);
  }

  #onChangeError(error: AppError): void {
    this.#globalToastService.showErrorWithTitle(error?.originalError?.error?.error_description);
  }
}
